/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.services {
    export class TimeTrackerService extends services.DataService<Wars.Domain.Model.Workflow.TimeTracker> {
        constructor(injectedBreeze: typeof breeze, $q: angular.IQService) {
            super(injectedBreeze, $q);
            this.$q = $q;
        }

        public createTimePeriod(timeTracker: Wars.Domain.Model.Workflow.TimeTracker): Wars.Domain.Model.Workflow.
            TimePeriod {
            var timePeriod = this.createNewEntity<Wars.Domain.Model.Workflow.TimePeriod>("TimePeriod");
            timePeriod.timeTracker_id = timeTracker.id;

            return timePeriod;
        }

        public createTimeTrackerContainer(processConfigId: string): Wars.Domain.Model.Workflow.TimeTrackerContainer {
            var timeTrackerContainer = this
                .createNewEntity<Wars.Domain.Model.Workflow.TimeTrackerContainer>("TimeTrackerContainer");
            timeTrackerContainer.processConfiguration_id = processConfigId;
            timeTrackerContainer.isIndexed = false;

            return timeTrackerContainer;
        }

        public createTimeTracker(): Wars.Domain.Model.Workflow.TimeTracker {
            var timeTracker = this.createNewEntity<Wars.Domain.Model.Workflow.TimeTracker>("TimeTracker");
            timeTracker.uniqueIdentifier = UtilityService.generateGuidComb();
            timeTracker.timeType = Wars.Domain.Model.Workflow.TimeType.Days;
            timeTracker.useBusinessHours = false;
            timeTracker.sortOrder = 0;
            return timeTracker;
        }

        public getTimeTrackerContainersByProcess(processConfigId: string): ng.
            IPromise<Wars.Domain.Model.Workflow.TimeTrackerContainer[]> {
            const query = this.breezeModule.EntityQuery
                .from("TimeTrackerContainers")
                .where('processConfiguration_id', '==', processConfigId)
                .expand('myTimeTracker.myTimePeriods, myTimeTracker.myClockStates')
                .orderBy("myTimeTracker.name");

            return <any>(this.executeQuery(query));
        }

        public getTimeTracker(id: string): ng.IPromise<Wars.Domain.Model.Workflow.TimeTracker> {
            return this.fetchById(id, "TimeTracker");
        }

        public getTimeTrackerStringValue(json: string): number{
            // TODO: Need to pull configured timezone into this somehow 

            var timeTrackerObj = JSON.parse(json);

            if (timeTrackerObj.ClockStatus === Wars.Domain.Model.Codes.Enums.ClockStatus.Running) {
                let currentDate: any = new Date();
                let milleseconds = Math.floor(currentDate - <any>new Date(timeTrackerObj.DateTimeClockValueLastChanged));
                let seconds =  Math.floor(milleseconds / 1000);
                var minutes = Math.floor(seconds / 60);
                var hours = Math.floor(minutes / 60);
                var days = Math.floor(hours / 24);

                if (timeTrackerObj.TimeType === Wars.Domain.Model.Workflow.TimeType.Days) {
                    return timeTrackerObj.TimeElapsedLastCalculated + days;
                }
                else if (timeTrackerObj.TimeType === Wars.Domain.Model.Workflow.TimeType.Hours) {
                    // TODO: When we implement minutes figure this out
                    return timeTrackerObj.TimeElapsedLastCalculated + hours;
                }
                else if (timeTrackerObj.TimeType === Wars.Domain.Model.Workflow.TimeType.Minutes) {
                    // TODO: When we implement minutes figure this out
                    return timeTrackerObj.TimeElapsedLastCalculated + minutes;  
                }
            }

            return timeTrackerObj.TimeElapsedLastCalculated;
        }

        public createClockState(): Wars.Domain.Model.Clocks.ClockState {
            return <Wars.Domain.Model.Clocks.ClockState>(this.createNewEntity("ClockState"));
        }
    }
}

warsApp.registerService('TimeTrackerService', ['breeze', '$q']);